// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentIso18013Proximity
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.eventlogger.fromDataItem

fun EventPresentmentIso18013Proximity.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "sJzKRLxz5AU812lYybIbn3W7Zeo5Ym6f1qtlwaSaua0")
val EventPresentmentIso18013Proximity_cborSchemaId = ByteString(-80, -100, -54, 68, -68, 115, -28, 5, 60, -41, 105, 88, -55, -78, 27, -97, 117, -69, 101, -22, 57, 98, 110, -97, -42, -85, 101, -63, -92, -102, -71, -83)

fun EventPresentmentIso18013Proximity.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PresentmentIso18013Proximity")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentData", this.presentmentData.toDataItem())
    builder.put("request", this.request)
    builder.put("response", this.response)
    builder.put("sessionTranscript", this.sessionTranscript)
    return builder.end().build()
}

fun EventPresentmentIso18013Proximity_fromDataItem(dataItem: DataItem): EventPresentmentIso18013Proximity {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentData = EventPresentmentData.fromDataItem(dataItem["presentmentData"])
    val request = dataItem["request"]
    val response = dataItem["response"]
    val sessionTranscript = dataItem["sessionTranscript"]
    return EventPresentmentIso18013Proximity(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentData = presentmentData,
        request = request,
        response = response,
        sessionTranscript = sessionTranscript,
    )
}
